module.exports = __webpack_public_path__ + "static/augustus_3_square-6b4ff0bc1132c9fdcf398ad3de716167.jpg";